import React from 'react'
import CloseSvg from 'images/modules/Shared/i-close.svg?raw'

export { default as CloseUrl } from 'images/modules/Shared/i-close.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CloseSvg}} />
)
